import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { LoyaltyOverviewSection } from "Components/Loyalty/Shared/Overview/LoyaltyOverviewSection";
import { RulesLink } from "Components/Loyalty/Stardust/RulesLink";
import { Resources } from "Translations/Resources";

const OVERVIEW = Resources.Pages.Content.Stardust.Overview;

export const OverviewSection = () => (
  <LoyaltyOverviewSection
    config={{
      pointsResources: OVERVIEW.Points,
      pointsIcon: <AutoAwesomeIcon />,
      payoutResources: OVERVIEW.Payout,
      rewardsResources: OVERVIEW.Rewards,
      myShareResources: OVERVIEW.MyShare,
      RulesLink: <RulesLink />,
    }}
  />
);
